document.addEventListener("change", (event) => {
  const variantSelect = event.target.closest("[data-variant-select]");
  if (!variantSelect) return;

  const form = variantSelect.closest("form");
  const selectedOption = variantSelect.selectedOptions[0];
  const available = selectedOption?.dataset.available === "true";
  const submit = form?.querySelector("[data-add-to-cart]");

  if (submit) {
    submit.disabled = !available;
    submit.textContent = available ? "Add to Cart" : "Sold Out";
  }
});

let cartSaveTimer;

document.addEventListener("input", (event) => {
  const quantityInput = event.target.closest("[data-cart-quantity]");
  if (!quantityInput) return;

  const form = quantityInput.closest("[data-cart-form]");
  const status = form?.querySelector("[data-cart-save-status]");
  if (!form) return;

  if (status) status.textContent = "Saving…";
  window.clearTimeout(cartSaveTimer);
  cartSaveTimer = window.setTimeout(() => {
    form.submit();
  }, 650);
});

document.addEventListener("click", (event) => {
  document.querySelectorAll(".account-menu[open]").forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute("open");
  });
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  document.querySelectorAll(".account-menu[open]").forEach((menu) => menu.removeAttribute("open"));
});
